export class widgetStatistics {

  static createUserRedirectionStatisticsEvent( tabName: string, clickType: string, openUrl: string) {
      const label = [
        'tab:' + tabName,
        'clickType:' + clickType, //right, left, keyboard
        openUrl ? 'openUrl:' + openUrl : ''
      ].join('###');

      return this.__trackClick(label);
  }

  private static __trackClick(label) {
      return {
        category: 'widget-cta-product-selector',
        action: 'click',
        label: label
      };
  }
}
